module.exports = __webpack_public_path__ + "static/img/编组1.a137947.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/编组1.png
// module id = LMLV
// module chunks = 1